
export function getBenefitAmountFrom(benefitAmounts, ageCategoryKey, babysittingModeKey, hoursType, defaultValue) {
  const key = ageCategoryKey + babysittingModeKey + hoursType
  const amount = benefitAmounts[key] ? benefitAmounts[key].amount : 0
  return amount || defaultValue
}
